import productName from '@src/utils/productName';

export function mapGetOneProductData(responseData) {
    if (!responseData) return responseData;

    return {
        ...responseData,
        id: responseData.slug || responseData.id,
        productId: responseData.id,
        name: productName(responseData.name, responseData.platform),
        isNew: responseData.is_new,
        useProductStateAvailability: responseData.use_product_state_availability,
        hidden: Boolean(responseData.hidden),
        direct_link_only: Boolean(responseData.direct_link_only),
        status: responseData.status || 'draft',
        published_at: responseData.published_at,
        expired_at: responseData.expired_at,
        show_in_search: responseData.show_in_search === undefined ? true : Boolean(responseData.show_in_search),
        show_in_filters: responseData.show_in_filters === undefined ? true : Boolean(responseData.show_in_filters),
        productStates: responseData.product_states ?
            responseData.product_states.map((state) => ({
                ...state,
                availabilityMapStatus: state.availability_map_status,
                productAvailable: state.product_available,
            })) :
            [],
    };
}

export function mapGetListProductsData(responseData) {
    if (!Array.isArray(responseData)) return responseData;

    return responseData.map((data) => mapGetOneProductData(data));
}
